module.exports = __webpack_public_path__ + "static/media/operador-logo-swile.fae93969.svg";